export type CourseCertificateEligibilityInput = {
    isFree: boolean;
    hasCertificate: boolean;
};

export const isCertificateAvailableForCourse = (
    course: CourseCertificateEligibilityInput,
    isCourseCompleted: boolean,
): boolean => isCourseCompleted && !course.isFree && Boolean(course.hasCertificate);
